module.exports = __webpack_public_path__ + "static/media/G1246957_Japan-05.c27617ef.png";